export const EmptyWrapper = ({ children }: { children: React.ReactNode }) => {
  return <>{children}</>
}
